import { map, join, pluck } from "ramda";
import i18n from "@/i18n";
import { displayFundField } from "@fng/common/fund/displayFundField";

export default (fund) => {
  const displayField = displayFundField(fund);

  const body = [];

  const t = (key) => i18n.t(key, fund.language);

  const value = (key) => {
    if (!displayField(key)) return;

    body.push([t(`fund.data.${key}`), fund[key]]);
  };

  const bool = (key) => {
    if (!displayField(key)) return;

    if (fund[key]) {
      body.push([t(`fund.data.${key}.title`), t(`fund.data.${key}.description`)]);
    }
  };

  const push = (key, data) => {
    if (!displayField(key)) return;

    body.push(data);
  };

  value("name");
  push("company.name", [t("fund.data.company.name"), fund.user.company.address.name]);
  bool("assetManagement");
  bool("fof");

  if (!(fund.assetClasses && fund.assetClasses.length)) {
    body.push([t("fund.data.imported.title"), t("fund.data.imported.description")]);
  } else {
    push("assetClasses", [
      t("fund.data.assetClasses"),
      join(
        ", ",
        map((val) => t(`fund.assetClasses.${val}`), fund.assetClasses)
      ),
    ]);

    value("assetClassesComment");
    value("assetManager");
    push("isins", [t("fund.data.isins"), join(", ", fund.isins)]);
    bool("privateInvestors");
    value("benchmark");
    value("fundType");
    push("investmentApproaches", [
      t("fund.data.investmentApproaches"),
      join(
        ", ",
        map((val) => t(`fund.investmentApproaches.${val}`), fund.investmentApproaches)
      ),
    ]);
    push("tranches", [
      t("fund.data.tranches"),
      join(
        ", ",
        map((val) => t(`fund.tranches.${val}`), fund.tranches || [])
      ),
    ]);
    value("tranchesComment");
    bool("performanceFee");
    bool("rter");
    push("salesCountries", [
      t("fund.data.salesCountries"),
      join(
        ", ",
        map((val) => t(`countries.${val}`), fund.salesCountries)
      ),
    ]);
    push("investmentRegion", [t("fund.data.investmentRegion"), t(`fund.investmentRegions.${fund.investmentRegion}`)]);

    if (fund.investmentRegionComment) value("investmentRegionComment");

    value("volume");
    value("currency");
    push("launchDate", [t("fund.data.launchDate"), new Date(fund.launchDate).toLocaleDateString()]);
    value("language");
  }

  if (fund.referenceFund) {
    push("referenceFund", [
      t("fund.data.referenceFund"),
      `${fund.referenceFund.name} (${fund.referenceFund.auditPeriod.year})`,
    ]);
  }

  if (fund.referencingFunds.length) {
    push("referencingFunds", [t("fund.data.referencingFunds"), join(", ", pluck("name", fund.referencingFunds))]);
  }

  push("disclosure", [t("fund.data.disclosure"), t(`disclosure.${fund.disclosure}`)]);
  value("disclosureComment");
  value("thirdPartyComment");
  value("comment");

  return {
    style: "requirementTable",
    table: {
      widths: [150, "*"],
      body,
    },
    margin: [0, 0, 0, 20],
  };
};
